import React, { Component, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Utility from "../../utility/Utility";
import { deepClone } from "../../utility/Utility"
import { DKLabel, DKButton, DKSpinner,DKInput,INPUT_TYPE,INPUT_VIEW_DIRECTION, showLoader, removeLoader,DKListPicker,DKCalendar,TOAST_TYPE, showToast} from "deskera-ui-library";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
// import { parseColumnConfig, PayrollLiabilityColumnConfig, SyncRevertJEBooksIntegrationColumnConfig } from "../../../configs/config";
// import { fetchPayrollLiabilityReport, selectPayrollLiability, addColumnToPayrollLiabilityColumnConfig } from "../../../../Redux/Slices/PayrollLiabilityReportSlice";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import ImportLogService from "../../services/ImportLogService";
import { fetchImportLog, selectImportLog } from "../../Redux/Slices/ImportLogSlice";
import { ImportLogColumnConfig, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import RouteManager from "../../managers/RouteManager";
import AttachmentService from "../../services/AttachmentService";
import { saveAs } from 'file-saver';

const ImportLogGrid = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    //State hooks
    
    const [importLog, setImportLog] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [reload, setReload] = useState(false);
    //Store data selectors
    const dispatch = useDispatch();
    const selectImportLogData = useSelector(selectImportLog);
    // const columnConfig = useSelector(addColumnToPayrollLiabilityColumnConfig);
    const isActionEnabled = false;

    useEffect(() => {
        RouteManager.setPresenter({ props });

        showLoader();
        /* API Calls Start */
        loadImportLog({});

        const column = parseColumnConfig(TableManger.getTableColumns(TABLES.IMPORT_LOG));
        const reportColumn = parseVisibleColumnConfig(column);
        const passingData = {
            columnData: deepClone(reportColumn),
            rowData: [],
            filter: [],
            originalData: [],
        };

        setImportLog(passingData);

        /* API Calls End */
        return () => {
            window.openSelectedLocation = () => {};
            setImportLog(initialState);
        };
    }, []);

    useEffect(() => {
        if (!Utility.isEmpty(selectImportLogData)) {
            const { content, pageable,totalPages,totalElements } = selectImportLogData;
            const functionConfig = getFunctionConfig();
            const rowData = ImportLogColumnConfig(content,functionConfig);
            let column = parseColumnConfig(TableManger.getTableColumns(TABLES.IMPORT_LOG))
            let reportColumn = parseVisibleColumnConfig(column)
            const passingData = {
                columnData: deepClone(reportColumn),
                rowData,
                filter: [],
                originalData: rowData
            };
            removeLoader();
            setImportLog(passingData);
            setTotalPageCount(totalPages);
            setCurrentPage(pageable.pageNumber+1);
            setTotalCount(totalElements)
        }
    }, [selectImportLogData,reload]);

    const loadImportLog = async (config) => {
        try {
            showLoader()
            ImportLogService.apiConfig = config;
            await dispatch(fetchImportLog());
            removeLoader()
        } catch (err) {
            removeLoader()
            console.error('Error loading import log: ', err);
        }
    };
    

    const onRowEdit = (data) => {
       
    };
    const onSearch = (searchTerm) => {
       
    };
    const newColumnAdded = (data) => {
        
    };

    const onFilter = (updatedList, queries) => {
        
    };

    const onRowAdd = (newRow) => {
        
    };
    const onRowDelete = (newRow) => {
        
    };
    const getFilename = (url) => {
        return url.substring(url.indexOf("_") + 1, url.length);
    }
    const download = (log,path) => {

        if (log.rowData && log.rowData.data[path]) {
            showLoader("Downloading attachment... Please wait");
            AttachmentService.getPresignedURL(log.rowData.data[path]).then((response) => {
                AttachmentService.downloadFile(response).then((response) => {
                    removeLoader();
                    saveAs(response, getFilename(log.rowData.data[path]));
                }, (error) => {
                    removeLoader()
                })
            })
        } 
        
    }

    const getFunctionConfig = () => {
        let config = {
            "downloadRejected": downloadRejected,
            "downloadUpdated": downloadUpdated
        };
        return config;
    };
    const downloadRejected = (data) => {
        download(data,'rejectedFilePath')
    }
    const downloadUpdated = (data) => {
        download(data,'updatedFilePath')
    }
    const downloadFile = (data) => {
        download(data,'filePath')
    }
    return(
        <div>
            <div className="column parent-width ">
            <div className="column  parent-width  position-relative  ">
                    <DataGridHolderPayroll
                        tableName={TABLES.IMPORT_LOG}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.IMPORT_LOG]}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        onRowDelete={onRowDelete}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}
                        onDownloadAttachment={(data) => {
                            downloadFile(data)
                        }}
                        allowDataExport={false}
                        gridData={importLog}
                        onSearch={onSearch}
                        onColumnAdd={newColumnAdded}
                        onFilter={onFilter}
                        filter={importLog.filter}
                        onRowAdd={onRowAdd}
                        onPaginationClick={(requestedPageNumber) => {
                            const config = {
                                ...ImportLogService.apiConfig,
                                page: requestedPageNumber - 1
                            };
                            loadImportLog(config);
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={true}
                        isHeaderHidden={false}
                        onRowOpenBtnHidden={true}
                        onColumnShift={(data)=> setReload(!reload)}
                    />
                </div>
            </div>
        </div>
    )
}
export default ImportLogGrid